import { FileTextIcon, ZapIcon, ActivityIcon, SmartphoneIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Instant download'
}, {
  icon: ActivityIcon,
  label: 'All ages and conditions'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: ZapIcon,
  label: 'Lifetime Access'
}];
export const stats = [{
  value: '500+',
  label: "Happy families"
}, {
  value: "6 + 5",
  label: "Volumes + Bonus"
}, {
  value: '4.9/5',
  label: "Rating ⭐⭐⭐⭐⭐"
}, {
  value: '99%',
  label: 'Would recommend it'
}];